import React from 'react';

const DeFlag = () => {
  return (
    <svg
      width="24"
      height="18"
      viewBox="0 0 24 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3915_1289)">
        <rect width="24" height="18" rx="2" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M-1 12.3335H25.6667V19.0002H-1V12.3335Z"
          fill="#FFD018"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M-1 5.6665H25.6667V12.3332H-1V5.6665Z"
          fill="#E31D1C"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M-1 -1H25.6667V5.66667H-1V-1Z"
          fill="#272727"
        />
      </g>
      <defs>
        <clipPath id="clip0_3915_1289">
          <rect width="24" height="18" rx="2" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DeFlag;
